import { Navigate } from "react-router-dom";
import { useUser } from "./user_context";

export default function AdminRoute({ children }) {
  const { userData, loading } = useUser();

  if (loading) return null;

  if (!userData) {
    return <Navigate to="/signin" replace />;
  }

  if (!userData.isAdmin) {
    return userData.role === "employer"
      ? <Navigate to="/employer/dashboard" replace />
      : <Navigate to="/dashboard" replace />;
  }

  return children;
}
